/*
Copyright (C) 2009 - 2019 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import { get } from 'lodash';

/**
 * @typedef {Object} ImageAssetRef
 * @property {string} contentUrl - the image asset content url
 */

/**
 * @typedef {Object} OrderItem
 * @property {ImageAssetRef} imageAsset - the item image asset
 */

/**
 * Retrieves the thumbnail URL for the order item.
 *
 * @param {OrderItem} orderItem the order item
 * @return {string|null|undefined}
 */
export function getOrderItemThumbnailUrl(orderItem) {
  return get(orderItem, 'imageAsset.contentUrl');
}

export function getCompletionPercentage(status) {
  switch (status) {
    case 'NEW':
    case 'CANCELLED':
      return '0%';
    case 'FULFILL_FAILED':
    case 'FULFILLING':
      return '33%';
    case 'FULFILLED':
    case 'PAYMENT_CAPTURE_FAILED':
      return '50%';
    case 'CAPTURING_PAYMENT':
    case 'CAPTURE_AWAITING_RESULT':
      return '66%';
    case 'PAYMENT_CAPTURED':
      return '100%';
    default:
      return '0%';
  }
}
